import routing from "./app.routes";

//Include global app stylesheets
import "./assets/stylesheets/main.style.scss";
//import "angular-ui-bootstrap/src/datepicker/datepicker.css";

//Include global app modules
import ladda from "angular-ladda";
import uibs from "angular-ui-bootstrap";
import angularAnimate from "angular-animate";
import ngCookies from "angular-cookies";
import ngFileUpload from "ng-file-upload";
// import moment from "moment";
import datepicker from "angular-ui-bootstrap/src/datepicker/index-nocss";

//Features
import account from "features/account";
import hmr from "features/referral";
import pharmacist from "features/pharmacist";

//Controllers
import AppController from "./controllers/app.controller";

//Directive
import abnOrAcnDirective from "./directives/abnOrAcn.directive";
import autofocusDirective from "./directives/autofocus.directive";
import bodyClassesDirective from "./directives/bodyClasses.directive";
import compareToDirective from "./directives/compareTo.directive";
import fileUploadDirective from "./directives/fileupload.directive";
import formValidatorDirective from "./directives/formValidator.directive";
import hmrNotificationsDirective from "./directives/hmrNotifications.directive";
import mrnDirective from "./directives/mrn.directive";
import passwordDirective from "./directives/password.directive";
import postcodeDirective from "./directives/postcode.directive";
import providerNumberDirective from "./directives/providerNumber.directive";
import redirectHrefDirective from "./directives/redirectHref.directive";
import relationshipRuleDirective from "./directives/relationshipRule.directive";
import relationshipTableDirective from "./directives/relationshipTable.directive";
import requiredNotDirective from "./directives/required-not.directive";
import templateDirective from "./directives/template.directive";

//Filters
import timeSpentFilter from "./filters/timeSpent.filter";

//Services
import CommonData from "services/common-data.service";
import RequestInterceptorService from "services/request.interceptor.service";
import UndefinedDataService from "../services/undefined-data.service";

//Add to angular
export default angular.module(
  "hmrx.app",
  [
    account,
    hmr,
    pharmacist,
    ladda,
    angularAnimate,
    uibs,
    ngCookies,
    ngFileUpload,
    datepicker,
    abnOrAcnDirective,
    autofocusDirective,
    bodyClassesDirective,
    compareToDirective,
    fileUploadDirective,
    formValidatorDirective,
    hmrNotificationsDirective,
    mrnDirective,
    passwordDirective,
    postcodeDirective,
    providerNumberDirective,
    redirectHrefDirective,
    relationshipRuleDirective,
    relationshipTableDirective,
    requiredNotDirective,
    templateDirective,
    timeSpentFilter,
    RequestInterceptorService,
    UndefinedDataService,
    CommonData,
  ]
)
  .config(routing)
  .config([
    "$httpProvider",
    function ($httpProvider) {
      $httpProvider.interceptors.push("RequestInterceptorService");
    },
  ])
  //Add all controllers
  .controller("AppController", AppController)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/index.js
 **/